import React from 'react';
import { withRouter } from 'react-router-dom';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@material-ui/core';

//Nivel
import AppAdmin, { MenusAdmin } from './RouterNivel/Administrador';
// import AppUser, { MenusUser } from './RouterNivel/Usuario';

//Components
import AppHeader from './components/AppHeader';
import Sidebar from './components/Sidebar';

//API
import AuthAPI from '../services/api/Auth';

//css
import './index.css';


class App extends React.Component {

	handlerInterval = undefined;

	state = {
		toolbarColor:false,
		sidebarSmall:false,
		modalSessao:false,
	}
	componentDidMount(){
		window.addEventListener('scroll', this.handleScroll);

		this.handlerInterval = setInterval(() => {
			AuthAPI.refresh().then(rs => rs.json())
							 .then(rs => {
								if(rs === false){
									this.setState({modalSessao: true});
								}
							 });
		}, 60000 * 2);
    }
    handleScroll = () => {
		const { toolbarColor } = this.state;
		let size = window.pageYOffset;
		if( size > 1 && toolbarColor === false ){
			this.setState({toolbarColor: true})
		}
		if(size === 0 && toolbarColor === true){
			this.setState({toolbarColor: false})
		}
	};
	handleSidebar = () => {
		const {sidebarSmall} = this.state;
		this.setState({sidebarSmall:!sidebarSmall})
	}

	componentWillUnmount() {
		clearInterval(this.handlerInterval);
		window.removeEventListener('scroll', this.handleScroll);
	}
    render() {
		const { modalSessao } = this.state;
		// const { nivel } = this.props;
		const nivel = 'admin';
        return (
				<div className="app_control" >
					<Sidebar menus={MenusAdmin} />
					<content className="app_control__content" >
						<AppHeader local={TextLocationByURL(MenusAdmin, this.props.location.pathname)} />
						<div className="section__switch" >
							{SelectRouter(nivel)}
						</div>
						<Dialog
							open={modalSessao}
							aria-labelledby="alert-dialog-title"
							aria-describedby="alert-dialog-description"
							>
							<DialogTitle id="alert-dialog-title">Você não está logado!</DialogTitle>
							<DialogContent>
								<DialogContentText id="alert-dialog-description">
									Sua sessão expirou. Faça login novamente clicando no botão "Fazer login".
								</DialogContentText>
							</DialogContent>
							<DialogActions>
								<Button onClick={() => this.props.history.push('/painel/entrar')} color="primary" autoFocus>
									Fazer Login
								</Button>
							</DialogActions>
						</Dialog>
					</content>
				</div>
        );
    }
}

export default withRouter(App);


function SelectRouter(nivel){
	switch (nivel) {
		case 'admin':
			return <AppAdmin />;
		default:
			// return <AppUser />;
	}
}

function TextLocationByURL(array,localpath){
	let path = localpath.split('/', 3).join("/");
	return array.find( a => a.url === path );
}

// function SelectMenus(nivel){
// 	switch (nivel) {
// 		case 'master':
// 			return MenusMaster;
// 		case 'admin':
// 			return MenusAdmin;
// 		default:
// 			return MenusUser;
// 	}
// }



// WEBPACK FOOTER //
// ./src/painel/App.js